import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { EVENT_TYPE } from '../../../../constants/index';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';
import { fontWeight, lineHeight } from '@material-ui/system';

const useStyles = makeStyles(theme => ({
  root: {

  },
  contentBox: {
    display: 'flex',
    gap: pxToRem(32),
    paddingBottom: pxToRem(48),
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      flexDirection: "column",
      gap: pxToRem(12),
    },
    '&:last-child': {
      [theme.breakpoints.down('md')]: {
        paddingBottom: pxToRem(56),
      },
      '&:before': {
        display: 'none'
      }
    },
    '&:before': {
      background: '#DDDEDE',
      width: '100%',
      height: '1px',
      bottom: pxToRem(24),
      ...theme.mixins.left(0),
      position: 'absolute',
      content: '""'
    }
  },
  innerHeading: {
    flex: '0 0 35.1%',
    maxWidth: '35.1%',
    '& .mainHeading': {
      marginLeft: 0,
      marginBottom: 0,
      fontWeight: '400',
    }
  },
  innerContent: {
    width: '100%',
    '& .listWrapper': {
      padding: 0,
      '& .MuiListItem-root': {
        marginTop: pxToRem(12),
        padding: 0,
        '& .listItem': {
          fontSize: pxToRem(14),
          textDecoration: 'none',
          lineHeight: pxToRem(16),

          [theme.breakpoints.down('md')]: {
            fontSize: pxToRem(12),
          },
        },
        '& .socialWrapper': {
          display: 'flex',
          '& .socialIcon': {
            ...theme.mixins.marginRight(12),
            display: 'flex',
            '&:hover': {
              '& svg': {
                '& circle': {
                  fill: '#FF8707'
                }
              },
              [theme.breakpoints.down('md')]: {
                '& svg': {
                  '& circle': {
                    fill: '#000 !important'
                  }
                },
              },
            },
            '& svg': {
              [theme.breakpoints.down('sm')]: {
                width: pxToRem(37),
                height: pxToRem(37),
              },
              '& circle': {
                transition: 'ease 0.5s all',
                fill: '#000'
              }
            },

            [theme.breakpoints.down('md')]: {
              ...theme.mixins.marginRight(8),
            },
          }
        },
        '&:first-child': {
          marginTop: pxToRem(0),
        }
      }
    }
  },
  richTextOverride: {
    '& .sch-evnt-list': {
      '& .evnt-loc': {
        display: 'none'
      },
      '& .evnt-sch-time': {
        display: 'flex',
        flexWrap: 'wrap',
        '& p': {
          fontSize: pxToRem(14),
          lineHeight: pxToRem(16),
          fontFamily: theme.custom.fontFamily.primaryRegular,
          marginBottom: pxToRem(8),
          '&:first-child': {
            ...theme.mixins.marginRight(5)
          },

          [theme.breakpoints.down('md')]: {
            fontSize: pxToRem(12),
          },
        }
      },
      '& .notes-container': {
        '& .evnt-notes': {
          '& h4, & .note-desc': {
            fontSize: pxToRem(14),
            lineHeight: pxToRem(16),
            marginTop: 0,
            marginBottom: pxToRem(8),
          },
          '& h4': {
            display: 'none',
          },
          '&:before, &:after': {
            display: 'block',
            content: '""',
            height: '1px',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            margin: '4px 0',
          },
        },
      },
    }
  }
}));

export default useStyles;
